export default "__VITE_ASSET__CiNmM76r__"